<template>
    <div>
        <v-header headerTitle="专属审批事项清单" :isShowIcon="true"></v-header>
        <div class="empty">
            <div class="empty-card">
                <div>
                <img src="@/assets/images/empty.png" alt="">
            </div>
            <div class="tip">
                <div>还未制定专属审批事项清单</div>
                <div>请联系项目管家！</div>
            </div>
            <van-button>联系项目管家</van-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "",
    components: {
        'v-header': () => import('@/components/VHeader/index.vue')
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
<style lang="less" scoped>
.empty {
    padding: 12px 16px;

    .empty-card {
        height: 400px;
        border-radius: 4px;
        background: #FFF;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        color: #000;
        img{
            width: 198px;
            height: 198px;
        }
        .tip{
            text-align: center;
            line-height: 26px;
            margin-bottom: 20px;
        }
        .van-button {
            background: #0273C7;
            color: #FFF;
            border-radius: 8px;
        }
    }
}
</style>